export const THEMES = ["amber", "kitty"] as const;
export type Theme = (typeof THEMES)[number];

const STORAGE_KEY = "bordeciel:theme";
const DEFAULT: Theme = "amber";

function isTheme(v: string | null): v is Theme {
  return v === "amber" || v === "kitty";
}

export function readTheme(): Theme {
  const attr = document.documentElement.getAttribute("data-theme");
  return isTheme(attr) ? attr : DEFAULT;
}

export function writeTheme(t: Theme): void {
  document.documentElement.setAttribute("data-theme", t);
  try {
    localStorage.setItem(STORAGE_KEY, t);
  } catch {
    // storage disabled; attribute is authoritative
  }
}

export function nextTheme(t: Theme): Theme {
  return t === "amber" ? "kitty" : "amber";
}
